import { tCalendar } from '../../../lib/calendar-i18n';
import { inclusiveEndDayNumber, localDayNumber } from '../recurrence-dates';

/**
 * 일간(시간 축 + 표)의 시각 범위 글자 (2026-10-19 사용자 지시).
 *
 * 종전: 언제나 「9:00 – 6:00」 ⇒ 여러 날에 걸친 시각 일정이면 «어느 날» 9시·6시인지 안 보였다.
 * 이제:
 * ```
 * 하루 안          9:00 – 6:00                  (종전 그대로)
 * 여러 날 · 같은 달  26일 9:00 – 28일 6:00          (헤더에 연·월이 있으니 «일»만)
 * 여러 날 · 다른 달  10월 30일 9:00 – 11월 2일 6:00   (달이 바뀌면 «월·일»)
 * ```
 * ⚠ 날짜 셈은 월간 배치·상세 창과 같다 — 종료가 자정 정각이면 그 전날까지(「22:00 – 0:00」은 하루 안).
 * ⚠ 시각 글자 꼴(12시간제 · 오전/오후 없음)은 부르는 쪽이 넘긴다 — 일간 열의 종전 꼴 그대로 쓰려고.
 */
export function agendaRangeLabel(start: Date, end: Date, hm: (d: Date) => string): string {
  const startDay = localDayNumber(start);
  const endDay = inclusiveEndDayNumber(start, end);
  if (endDay <= startDay) return `${hm(start)} – ${hm(end)}`;

  const sameMonth = start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();
  const dateOf = (d: Date) => (sameMonth
    ? tCalendar('calendar.agenda.date_day', { d: d.getDate() })
    : tCalendar('calendar.agenda.date_month_day', { m: d.getMonth() + 1, d: d.getDate() }));
  return `${dateOf(start)} ${hm(start)} – ${dateOf(end)} ${hm(end)}`;
}
